export const decodeURIPath = (path) => decodeURIComponent(path).replace(/^\/+|\/+$/g, '');
//# sourceMappingURL=string.utils.js.map